package app.nestbridge.feature.progress.screen

import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data object ProgressScreen : Screen

data class ProgressState(
    val eventSink: (ProgressEvent) -> Unit,
) : CircuitUiState

sealed interface ProgressEvent
